// REFACTOR: migrate this into relevant domain when payment being migrated into customer-app.
import { StripeCardBrandsEnum } from "../../__generated__/graphql";
import AmericanExpress from "../assets/american-express.png";
import MasterCard from "../assets/master-card.png";

const BRAND_LABELS: Record<StripeCardBrandsEnum, string> = {
  [StripeCardBrandsEnum.AmericanExpress]: "American Express",
  [StripeCardBrandsEnum.DinersClub]: "Diners Club",
  [StripeCardBrandsEnum.Discover]: "Discover",
  [StripeCardBrandsEnum.Jcb]: "JCB",
  [StripeCardBrandsEnum.MasterCard]: "Mastercard",
  [StripeCardBrandsEnum.UnionPay]: "UnionPay",
  [StripeCardBrandsEnum.Visa]: "Visa",
  [StripeCardBrandsEnum.Unknown]: "Card",
};

const BRAND_IMAGES: Partial<Record<StripeCardBrandsEnum, typeof MasterCard>> = {
  [StripeCardBrandsEnum.AmericanExpress]: AmericanExpress,
  [StripeCardBrandsEnum.MasterCard]: MasterCard,
};

export const cardBrandLabel = (brand: StripeCardBrandsEnum) => BRAND_LABELS[brand] ?? "Card";

/** Brand artwork, or null when we have no image and should fall back to an icon. */
export const cardBrandImage = (brand: StripeCardBrandsEnum) => BRAND_IMAGES[brand] ?? null;
